import { Component, inject } from '@angular/core';
import { QuestionType } from '@empathy/survey/base';

import { SurveyConditionalsService } from '../../../../services/survey-conditionals.service';

@Component({
  selector: 'empathy-conditional-multi-select-form',
  templateUrl: './conditional-multi-select-form.component.html',
  styleUrls: ['./conditional-multi-select-form.component.scss']
})
export class ConditionalMultiSelectFormComponent {
  questionType = QuestionType;
  surveyConditionalsService = inject(SurveyConditionalsService);
}
